module.exports = new __parcel__URL__("light.f93d0cda.svg").toString();